// The `name` Rollbar's DOM-telemetry scrubber matches (shared/utils/rollbar_logger.js). Rollbar
// records every input's value on blur and attaches the trail to any report, so every input that
// holds a Confidential answer must carry this name; nothing else keys on it.
export const ROLLBAR_SCRUBBED_INPUT_NAME = 'confidential_answer';
